<template>
  <v-btn @click.stop="onClick" text small>
    <span id="RTE__command__italic">I</span>
  </v-btn>
</template>

<script>
export default {
  name: 'italic',
  methods: {
    onClick () {
      this.$emit('click', 'italic')
    }
  }
}
</script>

<style scoped>
#RTE__command__italic {
  font-style: italic;
  font-size: 20px;
}
</style>
